<template>
  <div class="form-group"
       :class="[ to.inputType, {'formly-has-value': model[field.key], 'formly-has-focus': form[field.key].$active, 'has-error': hasError}]">
    <label v-if="to.label" v-text="$t('formly.fields.' + to.label)"></label>
    <multiselect
      :track-by="'formattedAddress'"
      :label="'formattedAddress'"
      @search-change="getOptions"
      :placeholder="$t('select.search_address')"
      :close-on-select="true"
      v-model="model[field.key]"
      :options="options"
      :loading="isLoading"
      :internal-search="false"
      :clear-on-select="false"
      :options-limit="10"
      :show-no-results="true"
    >
      <template slot="singleLabel" slot-scope="{ option }">{{ option.formattedAddress }}</template>
      <template slot="option" slot-scope="{ option }">
        <div>{{ option.formattedAddress }}</div>
      </template>
      <span slot="noResult">{{ $t('select.no_results') }}</span>
    </multiselect>
    <div v-if="model[field.key]" class="mt-2 p-3 border rounded bg-light small">
      <div v-if="model[field.key].street" class="mb-2">
        <div class="text-muted mb-1" style="font-size: 0.75rem; letter-spacing: 0.02rem;">{{ $t('address.street') }}</div>
        <div><strong>{{ model[field.key].street }} {{ model[field.key].streetNumber }}</strong></div>
      </div>
      <div v-if="model[field.key].city" class="mb-2">
        <div class="text-muted mb-1" style="font-size: 0.75rem; letter-spacing: 0.02rem;">{{ $t('address.city') }}</div>
        <div><strong>{{ model[field.key].postcode }} {{ model[field.key].city }}</strong></div>
      </div>
      <div v-if="model[field.key].municipality" class="mb-2">
        <div class="text-muted mb-1" style="font-size: 0.75rem; letter-spacing: 0.02rem;">{{ $t('address.municipality') }}</div>
        <div><strong>{{ model[field.key].municipality }}</strong></div>
      </div>
      <div v-if="model[field.key].state" class="mb-2">
        <div class="text-muted mb-1" style="font-size: 0.75rem; letter-spacing: 0.02rem;">{{ $t('address.state') }}</div>
        <div><strong>{{ model[field.key].state }}</strong></div>
      </div>
      <div v-if="model[field.key].country" class="mb-2">
        <div class="text-muted mb-1" style="font-size: 0.75rem; letter-spacing: 0.02rem;">{{ $t('address.country') }}</div>
        <div><strong>{{ model[field.key].country }}</strong></div>
      </div>
      <div v-if="model[field.key].timezone">
        <div class="text-muted mb-1" style="font-size: 0.75rem; letter-spacing: 0.02rem;">{{ $t('address.timezone') }}</div>
        <div><strong>{{ model[field.key].timezone }}</strong></div>
      </div>
    </div>
    <error-display :form="form" :field="field.key"></error-display>
  </div>
</template>

<script>
import ApiService from '@/services/api.service'
import baseField from 'vue-formly-bootstrap/src/fields/baseField'
import Multiselect from 'vue-multiselect'
import ErrorDisplay from '../formly-bootstrap/components/errorDisplay'
import { debounce } from '@/lib/debounce'

export default {
  mixins: [baseField],
  data () {
    return {
      options: [],
      isLoading: false
    }
  },
  components: {
    Multiselect,
    ErrorDisplay
  },
  methods: {
    getOptions: debounce(function (q) {
      if (!q) {
        this.options = []
        return
      }

      this.isLoading = true
      ApiService.get('api/v1/admin/search/addresses', { params: { search: q } })
        .then((response) => {
          this.options = response.data
        })
        .finally(() => {
          this.isLoading = false
        })
    }, 400)
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
